import React, { createContext, useState, useEffect, useContext } from 'react'
import initializeWebSocketInstance from '../../../utils/webSocketUtils'
import { useUrlWebSocket } from '../../../redux/zustand/webSocketUrl'

const WebSocketContext = createContext(null)

export const WebSocketProvider = ({ apiUrlSocket, children }) => {
    const [webSocketInstance, setWebSocketInstance] = useState(null)
    const { urlWebSocket } = useUrlWebSocket()
    
    const effectiveUrl = apiUrlSocket || urlWebSocket

    useEffect(() => {
        console.log('🔧 [WebSocketContext] Setting up WebSocket', { apiUrlSocket, urlWebSocket, effectiveUrl })
        const connectToWebSocket = async () => {
            if (!effectiveUrl) return
            const instance = await initializeWebSocketInstance(effectiveUrl)
            setWebSocketInstance(instance)
        }

        connectToWebSocket()

        return () => {
            if (!effectiveUrl) {
                try {
                    // import dynamic to avoid circular requires in some bundlers
                    const { disconnectWebSocket } = require('../../../utils/webSocketUtils')
                    disconnectWebSocket()
                    setWebSocketInstance(null)
                } catch (e) {
                    // ignore
                }
            }
        }
    }, [effectiveUrl])

    return <WebSocketContext.Provider value={webSocketInstance}>{children}</WebSocketContext.Provider>
}

export const useWebSocket = () => useContext(WebSocketContext)
